import CompanyLogo1 from "@/assets/companies/healthgrades.svg";
import CompanyLogo2 from "@/assets/companies/bluecross_blueshield.svg";
import CompanyLogo3 from "@/assets/companies/allscripts.svg";
import CompanyLogo4 from "@/assets/companies/sutter_health.svg";
import { cn } from "@/lib/utils";
import DotPattern from "../ui/dot-pattern";

export type InfoCardProps =
  | {
      background: string;
      title?: string | React.JSX.Element;
      subtitle?: string;
      description?: string;
      source?: string;
      footer?: true;
      backgroundClass?: string;
      contentOverride?: never;
    }
  | {
      background?: never;
      title?: never;
      subtitle?: never;
      description?: never;
      source?: never;
      footer?: never;
      backgroundClass?: never;
      contentOverride: React.ReactNode;
    };

export const InfoCard = ({
  background,
  title,
  subtitle,
  description,
  source,
  footer,
  backgroundClass,
  contentOverride,
}: InfoCardProps) => {
  return (
    <div className="px-10 py-12 relative w-full h-full max-h-full min-h-0 flex flex-col gap-10 items-center justify-center text-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-accent to-secondary-dark to-40% -z-[3]" />
      <DotPattern
        width={24}
        height={24}
        className="absolute inset-0 min-w-full opacity-50 -z-[1]"
      />
      {contentOverride ?? (
        <div className="pt-9 relative w-full h-full max-h-full min-h-0 flex flex-col gap-10 items-center justify-center text-center">
          <div className="flex flex-col gap-6 self-stretch items-center">
            {title && (
              <h1 className="max-w-[75%] text-secondary-foreground text-3xl">
                {title}
              </h1>
            )}
            {subtitle && (
              <p className="max-w-[75%] text-secondary-foreground text-base opacity-90">
                {subtitle}
              </p>
            )}
          </div>
          <img
            src={background}
            alt="Onboarding Info Card Image"
            className={cn(
              "w-full max-w-full h-auto max-h-[50vh] rounded-md object-contain object-center",
              backgroundClass,
            )}
          />
          {description && (
            <p className="w-full text-secondary-foreground text-base">
              {description}
            </p>
          )}
          {source && (
            <p className="w-full text-secondary-foreground text-md">{source}</p>
          )}
          {footer && (
            <div className="w-full min-h-fit flex flex-col gap-6 items-center justify-center overflow-hidden">
              <p className="text-secondary-foreground">
                Featuring top talent from industry leaders
              </p>
              <div className="relative w-full flex flex-row items-center justify-between max-h-8 -z-[2] gap-4">
                <div className="absolute w-full h-full bg-gradient-to-r from-secondary-dark via-50% via-secondary-foreground/0 to-secondary-dark" />
                <img src={CompanyLogo1} alt="Healthgrades" />
                <img src={CompanyLogo2} alt="BlueCross BlueShield" />
                <img src={CompanyLogo3} alt="Allscripts" />
                <img src={CompanyLogo4} alt="Sutter Health" />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
